<template>
    <div>
        <!--Invite start-->
        <sweet-modal blocking ref="invite" :title="$t('modal_invite_user_title')" class="modal" v-on:close="closeModal">
            <el-form @submit.prevent.native="submitForm('form')" :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
                <el-row :gutter="20">
                  <el-col :span="13">
                    <el-form-item prop="inviteTo">
                        <el-radio-group :disabled="disabledBtn" @change="putOperation" v-model="operation" size="mini">
                            <el-radio-button label="company" border>{{$t('general_company')}}</el-radio-button>
                            <el-radio-button label="getBusinessUnitList" border>{{$t('general_bu')}}</el-radio-button>
                            <el-radio-button disabled label="getWarehouseList" border>Warehouse</el-radio-button>
                            <el-radio-button label="getEngagementList" border>{{$t('general_e')}}</el-radio-button>
                            <el-radio-button label="getProjectList" border>{{$t('general_project')}}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" :span="24">
                    <el-col :span="13">
                        <el-form-item prop="inviteEmail">
                            <el-input :label="$t('modal_email')" size="mini" v-model.trim="form.inviteEmail"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item prop="businessUnitId" v-if="this.operation !== 'getBusinessUnitList'">
                            <el-select :label="$t('general_bu')" size="mini" v-model="form.businessUnitId" :placeholder="$t('general_bu')" style="width:100%">
                                <el-option
                                        v-for="item in businessUnitList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div v-if="operation !== 'company'">
                    <el-row :span="24" :gutter="20">
                        <el-col :span="13">
                            <el-form-item prop="projectId">
                                <el-select :label="parent" :disabled="disabledBtn" size="mini" v-model="form.projectId" :placeholder="parent" style="width: 100%;">
                                    <el-option
                                            v-for="item in myProjectList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                            @click.native="getParentList(operation, item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item prop="taskId">
                                <el-select :disabled="disabledBtn" size="mini" v-model="form.taskId" :placeholder="child" style="width: 100%;">
                                    <el-option
                                            v-for="item in myTaskList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('invite')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
         <!--Reinvite Start-->
        <sweet-modal blocking ref="reinvite" class="modal">
            <h1 class="modal__title">Re-send invitation?</h1>
            <div class="reinvite-btn">
                <el-button @click="modalCancel('reinvite')">{{$t('general_cancel')}}</el-button>
                <el-button @click="resendSubmit()" type="primary">{{$t('general_submit')}}</el-button>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: 'inviteUserModal',
  components: {
    SweetModal,

  },
  data(){
    return {
      disabledBtn: false,
      parent: this.$i18n.t('general_project'),
      child: this.$i18n.t('general_task'),
      myProjectList:[],
      myTaskList: [],
      operation: 'company',
      resendEmail: '',
      businessUnitList: [],
      form: {
        businessUnitId: null,
        inviteEmail: '',
        projectId: null,
        taskId: null
      },
      rules: {
        inviteEmail: [
          { required: true, message: 'Please input Email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
        ],
        projectId: [
          { required: true, message: 'Please input Project', trigger: 'blur' }
        ],
        businessUnitId: [
            { required: true, message: 'Please input Business Unit', trigger: 'blur' }
        ],
        taskId: [
          { required: true, message: 'Please input Task', trigger: 'blur' }
        ],
      },
    }
  },
  methods:{
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    async openModal(){
      try {
       this.businessUnitList = await this.getBusinessUnit();
       await this.$refs.invite.open();
      }catch(err){
          console.log(err)
      }
    },
    getBusinessUnit(){
      return new Promise((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
              .then(response => {
                  loader.hide();
                  resolve(response.data.list)
              })
              .catch(error => {
                  loader.hide();
                  console.log('An error occurred:', error);
                  reject(error)
              });
      })
    },
    async openModalFromBasic(operation, projectId, taskId){
      try{
          this.operation = operation;
          this.disabledBtn = true;
          this.putOperation(this.operation);
          this.getParentList(this.operation, projectId);
          this.form.projectId = Number(projectId);
          this.form.taskId = taskId;
          // this.businessUnitList = await this.getBusinessUnit();
          await this.$refs.invite.open();
      }catch(err){
          console.log(err)
      }
    },
    async putOperation(operation){
      this.operation = operation;
      switch(operation){
        case 'getProjectList':
          this.parent = this.$t('general_project');
          this.child = this.$t('general_task');
          this.getParentList(operation, false);
          this.businessUnitList = [];
          this.form.businessUnitId = null;
          break;
        case 'getBusinessUnitList':
          this.parent = this.$t('general_bu');
          this.child = this.$t('general_task');
          this.getParentList(operation, false);
          this.businessUnitList = await this.getBusinessUnit();
          this.form.businessUnitId = null;
          break;
        case 'getEngagementList':
          this.parent = this.$t('general_e');
          this.child = this.$t('general_task');
          this.getParentList(operation, false);
          this.businessUnitList = [];
          this.form.businessUnitId = null;
          break;
        case 'company':
          this.businessUnitList = await this.getBusinessUnit();
          this.form.businessUnitId = null;
          break
      }
    },
    getParentList(operation, parentId){
      if(!parentId){
        this.myTaskList = []
        this.form.taskId = null
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUsers/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
          .then(response => {
            if(!this.disabledBtn){
              this.form.projectId = null
            }
            if(response.data.projectList){
              this.myProjectList = response.data.projectList;
            }else if(response.data.businessUnitList){
              this.myProjectList = response.data.businessUnitList
            }else if(response.data.engagementList){
              this.myProjectList = response.data.engagementList
            }

            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      }else{
        let url = '';
        switch(operation){
          case 'getProjectList':
            operation = 'getProjectTaskList';
            url = `/api/v1/companyUsers/directories?companyId=${this.$route.query.companyId}&operation=${operation}&projectId=${parentId}`;
            // GET BU LIST AFTER SELECT PROJECT
            this.businessUnitList = [];
            this.getBusinessUnitFromProjects(parentId);
            break;
          case 'getBusinessUnitList':
            operation = 'getBusinessUnitTaskList';
            url = `/api/v1/companyUsers/directories?companyId=${this.$route.query.companyId}&operation=${operation}&businessUnitId=${parentId}`;
            break;
          case 'getEngagementList':
            operation = 'getEngagementTaskList';
            url = `/api/v1/companyUsers/directories?companyId=${this.$route.query.companyId}&operation=${operation}&engagementId=${parentId}`;
            this.businessUnitList = [];
            this.getBusinessUnitFromEngagements(parentId);
            break
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(url)
          .then(response => {
            if(!this.disabledBtn) {
              this.form.taskId = null
            }
            if(response.data.projectTaskList){
              this.myTaskList = response.data.projectTaskList
            }else if(response.data.businessUnitTaskList){
              this.myTaskList = response.data.businessUnitTaskList
            }else if(response.data.engagementTaskList){
              this.myTaskList = response.data.engagementTaskList
            }
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      }
    },
    getBusinessUnitFromProjects(parentId){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/businessUnits/listForProject?companyId=${this.$route.query.companyId}&projectId=${parentId}`)
        .then(response => {
          loader.hide();
          this.businessUnitList = response.data.list;
          this.form.businessUnitId = null
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    getBusinessUnitFromEngagements(parentId){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/businessUnits/listForEngagement?companyId=${this.$route.query.companyId}&engagementId=${parentId}`)
        .then(response => {
          loader.hide();
          this.businessUnitList = response.data.list;
          this.form.businessUnitId = null
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    submitForm(form) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let data = {
            email: this.form.inviteEmail,
            projectId: null,
            projectTaskId: null,
            businessUnitId: this.form.businessUnitId,
            businessUnitTaskId: null,
            engagementId: null,
            engagementTaskId: null,
            type: 'dev'
          }
          switch(this.operation){
            case 'getProjectList':
              data.projectId = this.form.projectId
              data.projectTaskId = this.form.taskId
              break
            case 'getBusinessUnitList':
              data.businessUnitId = this.form.projectId
              data.businessUnitTaskId = this.form.taskId
              break
            case 'getEngagementList':
              data.engagementId = this.form.projectId
              data.engagementTaskId = this.form.taskId
              break
          }
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUsers/inviteUser?companyId=${this.$route.query.companyId}`, data)
            .then(response => {
              this.$refs.invite.close();
              loader.hide()
              this.notification("Success", "The invitation has been sent", "success");
              this.$refs['form'].resetFields();
            })
            .catch(error => {
              console.log('An error occurred:', error);
              this.resendEmail = this.form.inviteEmail
              // this.$refs.invite.close();
              if(error.response.data.message === 'invite_already_sended'){
                this.$refs.reinvite.open();
              }
              loader.hide()
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resendSubmit(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyUsers/reinviteUser?companyId=${this.$route.query.companyId}&email=${this.resendEmail}`)
        .then(response => {
          console.log('---', response.data);
          this.resendEmail = '';
          this.$refs.invite.close();
          this.$refs.reinvite.close();
          loader.hide()
          this.notification("Success", "Invitation sent", "success");
        })
        .catch(error => {
          console.log('An error occurred:', error);
          this.$refs.invite.close();
          this.$refs.reinvite.close();
          this.resendEmail = '';
          loader.hide()
        });
    },
    closeModal() {
      this.disabledBtn = false;
      this.operation = 'company';
      this.form.inviteEmail = '';
      this.form.projectId = null;
      this.form.taskId = null;
      this.businessUnitList = [];
      this.resendEmail = '';
      this.myProjectList = [];
      this.myTaskList = [];
      this.$refs['form'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  }
}
</script>

<style lang="less" scoped>
    .modal {
        &__title {
            text-align: center;
        }
        &__btn {
            text-align: right;
        }
    }
    .reinvite-btn{
        display:flex;
        justify-content:center;
    }
</style>
